import { render } from "./Spaces.vue?vue&type=template&id=3868817a&scoped=true"
import script from "./Spaces.vue?vue&type=script&lang=ts"
export * from "./Spaces.vue?vue&type=script&lang=ts"

import "./Spaces.vue?vue&type=style&index=0&id=3868817a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3868817a"

export default script